// Third-party
import React, { useState, useEffect } from 'react';
import { RouteComponentProps, withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

// HOC
import { ErrorBoundary } from '@/views/components/errors';

// Components
import { Header } from '@/views/components/layout';
import PageLayout from '../layouts/PageLayout';
import ScreenerContent from './pages/ScreenerContent';
import ScreenerInstrumentTabs from './partials/ScreenerInstrumentTabs';

// Utils
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';
import { userHasPermission, PERMISSIONS } from '@/utils/permissions';

// Types
import { ReduxState } from '@/redux/modules/types';

type Props = RouteComponentProps;

const Screener: React.FC<Props> = ({ location, history, ...props }) => {
  const user = useSelector((state: ReduxState) => state.auth.user);

  if (!user) {
    return null;
  }

  const searchPath = props.match.path;

  return (
    <>
      <Header />
      <PageLayout
        showHeader={false}
        pageTitle="Screener.Title"
        pillsFilterElement={<ScreenerInstrumentTabs user={user} />}
        layoutClassName="full-height"
        mainClassName="screener"
      >
        <ErrorBoundary>
          <Switch>
            <Route
              exact
              path={searchPath}
              render={(props: RouteComponentProps) => <ScreenerContent {...props} instrumentType={ADVANCED_SEARCH_OPTIONS.FUNDS} />}
            />

            <Route
              exact
              path={`${searchPath}/funds`}
              render={(props: RouteComponentProps) => <ScreenerContent {...props} instrumentType={ADVANCED_SEARCH_OPTIONS.FUNDS} />}
            />

            {user && userHasPermission(user, PERMISSIONS.BENCHMARKS) && (
              <Route
                exact
                path={`${searchPath}/benchmarks`}
                render={(props: RouteComponentProps) => <ScreenerContent {...props} instrumentType={ADVANCED_SEARCH_OPTIONS.BENCHMARKS} />}
              />
            )}

            {user && userHasPermission(user, PERMISSIONS.SCREENER_STOCKS) && (
              <Route
                exact
                path={`${searchPath}/stocks`}
                render={(props: RouteComponentProps) => <ScreenerContent {...props} instrumentType={ADVANCED_SEARCH_OPTIONS.STOCKS} />}
              />
            )}

            {user && userHasPermission(user, PERMISSIONS.SCREENER_BONDS) && (
              <Route
                exact
                path={`${searchPath}/bonds`}
                render={(props: RouteComponentProps) => <ScreenerContent {...props} instrumentType={ADVANCED_SEARCH_OPTIONS.BONDS} />}
              />
            )}

            <Redirect to={props.match.path} />
          </Switch>
        </ErrorBoundary>
      </PageLayout>
    </>
  );
};

export default withRouter(Screener);
